import type { UseQueryResult } from '@tanstack/react-query';
import type { UseFormReturn } from 'react-hook-form';
import type {
  Cidade,
  EnderecoOficialApresentado,
  Estado,
  MinhaParticipacao,
  Pais,
} from '../types/Formulario';
import type { Valores } from './formulario.utils';

/** Campos que uma escolha de passo muda (R3, R5). */
export type CampoEscolha = 'deseja' | 'decisao' | 'tamanho' | 'origem' | 'mesmo' | 'cadastro';

/** O que cada passo recebe do formulário (spec 33 §6.1). */
export type CtxPasso = {
  form: UseFormReturn<Valores>;
  participacao: MinhaParticipacao;
  /** Tamanho de camiseta da fotografia, ou `null`. */
  atual: string | null;
  cadastro: EnderecoOficialApresentado | null;
  /** O passo já tem resposta: mostra o Continuar (R3). */
  respondido: boolean;
  /** `undefined` no 1º passo. */
  onVoltar?: () => void;
  /** Próximo passo do caminho, sem validar (escolha sem campos, R3). */
  avancar: () => void;
  /** Valida os campos do passo (R4) e avança. */
  continuar: () => Promise<void>;
  /** Marca uma escolha e aplica a R5 (o oficial volta à fotografia quando o passo dono dele sai do caminho). */
  escolher: <K extends CampoEscolha>(campo: K, valor: Valores[K]) => void;
  /** R11 e "Alterar": abre o passo "cadastro" em "Corrigir". */
  corrigirCadastro: () => void;
  /** Valida de novo um campo que já está em erro, a cada mudança (R4, R7: o erro some ao preencher). */
  revalidar: (campo: string) => void;
  /** Entrega copiada para o oficial no passo "mesmo" (R8); muda quando a entrega muda. */
  copia: { current: string | null };
  paises: UseQueryResult<Pais[]>;
  estados: UseQueryResult<Estado[]>;
  cidades: UseQueryResult<Cidade[]>;
  /** id → nome das cidades conhecidas (lista, fotografia, resposta salva). */
  rotulosCidade: Record<string, string>;
  cidadeInicial: { id: string; nome: string } | null;
};

/** O `h2` do cartão: os grupos de opções se rotulam por ele. */
export const TITULO_PASSO = 'titulo-passo';
